import type { KeyboardEvent } from "react";

/**
 * Opens a team member's profile URL in a new tab.
 * @param url - The profile URL to open.
 * @returns The opened window handle, or null if blocked.
 */
export const openProfile = (url: string) => window.open(url, "_blank", "noopener,noreferrer");

/**
 * Activates a card via keyboard (Enter/Space) so a role="button" element behaves like a button.
 * @param e - The keyboard event from the card.
 * @param url - The profile URL to open on activation.
 * @returns Nothing.
 */
export const handleCardKeyDown = (e: KeyboardEvent, url: string) => {
  if (e.key === "Enter" || e.key === " ") {
    e.preventDefault();
    openProfile(url);
  }
};
